<template lang="pug">
  .form-main
    .formpage
      .right_col(role='main')
        .main_main_contents
          .page-title
            .title_left
              h2 フォーム編集
          .x_panel
            .x_content
              .form-group
                label.h3#control-label(for='title')  フォームのタイトル
                label.notice タイトル入力後、テキストボックス外をクリックしてください。
                input#form_title.form-control(type='text' v-model='title' @blur='changeTitle' placeholder='このフォームのタイトルを入力してください'
                v-bind:class='{invalid:$v.title.$dirty && $v.title.$invalid}'
                @input='$v.title.$touch')
                span.error(v-show='$v.title.$dirty && $v.title.$invalid')
                  p(v-show='!$v.title.required') 必須項目です
                  p(v-show='!$v.title.maxLength') 100文字以下で入力してください
              div(v-show='$route.params.id != `new`' role='tabpanel', data-example-id='togglable-tabs')
                ul.nav.nav-tabs.bar_tabs(role='tablist')
                  li.active(role='presentation')
                    a#recmail-tab(href='#mail_tab', role='tab', data-toggle='tab', aria-controls='recmail', aria-expanded='false') 送受信メール設定
                  li(role='presentation')
                    a#item-tab(href='#item_tab', role='tab', data-toggle='tab', aria-controls='item', aria-expanded='true') 項目設定
                .tab-content
                  #mail_tab.tab-pane.fade.in.active
                    #mailsetting(is='mail' :data.sync='form', role='tabpanel', aria-labelledby='recmail-tab')
                  #item_tab.tab-pane.fade
                    #itemsetting(is='item' :data.sync='form', role='tabpanel', aria-labelledby='item-tab')
</template>

<script>
import $ from 'jquery'
import Authenticate from '@/service/Authenticate'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'
import mail from '@/components/dashboard/form/Mail'
import item from '@/components/dashboard/form/Item'
import { required, maxLength } from 'vuelidate/lib/validators'
import { defaultParts, uniqId } from '@/components/dashboard/form/part/PartConfig'

export default {
  data () {
    console.log('index data')
    return {
      title: null,
      form: {
        id: '',
        contract_id: '',
        theme_color: '',
        items: '',
        item_list: [],
        notification_to: '',
        notification_cc: '',
        notification_bcc: '',
        thanks_title: '',
        thanks_header: '',
        thanks_footer: '',
        default_signature: '',
        include_inquiry_body: '',
        smtp_mail_address: '',
        smtp_server: '',
        smtp_port: '',
        smtp_secure: '',
        smtp_user: '',
        smtp_pass: '',
        form_description: '',
        is_agree: 0,
        agree_text: '',
        is_valid: '',
        iframe_height: '',
        iframe_width: '',
        embed_token: '',
        embed_iframe: '',
        created_at: '',
        updated_at: '',
        created_user_name: '',
        updated_user_name: ''
      }
    }
  },
  validations: {
    title: { required, maxLength: maxLength(100) }
  },
  mounted () {
    console.log('index mounted')

    if (this.$route.params.id !== 'new') {
      $('.notice').hide()
    }
    this.bind()
  },

  methods: {
    bind (formId = null) {
      // フォーム編集時または新規作成時のフォームタイトル入力後であればデータを取得する
      if (this.$route.params.id !== 'new' || formId !== null) {
        let vue = this
        this.$nextTick(() => {
          Loader.show()
        })
        let id = this.$route.params.id
        if (id === 'new') id = formId
        let axios = Request.instance(true)
        let result = axios.get('/form/' + id)
        result.then((res) => {
          vue.title = res.data.name
          for (let key in res.data) {
            vue.form[key] = res.data[key]
          }
          if (!vue.form.items) {
            // itemsがなければデフォルトを設定する
            vue.form.item_list = defaultParts.map((item) => {
              item.id = uniqId()
              return item
            })
          } else {
            // あればデシリアライズする
            vue.form.item_list = JSON.parse(vue.form.items)
          }

          vue.$nextTick(() => {
            this.thirdpartyInit()
            Loader.hide()
          })
        }).catch((error) => {
          Message.error(error.response.data.message)
        })
      }
    },
    thirdpartyInit () {
      let self = this
      $('.colorpicker').colorpicker().on('changeColor.colorpicker', function (event) {
        // 選択されたカラーコードを代入
        self.form.theme_color = $('.selectcolor').val()
        console.log($('.selectcolor').val())
      })
      $('.summernote').summernote({
        height: 300,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']]
        ],
        disableDragAndDrop: true,
        callbacks: {
          onChange: (contents, $editable) => {
            this.form.agree_text = contents
          }
        }
      })
    },
    changeTitle () {
      if (this.$v.title.$invalid) {
        return false
      }
      let axios = Request.instance(true)
      let self = this
      let currentUser = Authenticate.currentUser()
      if (this.$route.params.id === 'new') {
        axios.post('/form/new/title',
          qs.stringify({
            title: this.title,
            user: JSON.stringify(currentUser)
          })
        ).then((response) => {
          Message.show('success', ['タイトルを更新しました'])
          self.$router.push(response.data.id)
          self.bind(response.data.id)
          $('.notice').hide()
        }).catch((error) => {
          Message.error(error.response.data.message)
        })
      } else {
        axios.put('/form/' + this.$route.params.id + '/title',
          qs.stringify({
            title: this.title,
            user: JSON.stringify(currentUser)
          })
        ).then((response) => {
          Message.show('success', ['タイトルを更新しました'])
        }).catch((error) => {
          Message.error(error.response.data.message)
        })
      }
    }
  },
  components: {
    mail: mail,
    item: item
  }
}
</script>

<style lang="stylus">
.radio02-input
  display: none
  + label
    padding-left: 20px
    position: relative
    margin-right: 20px
    cursor: pointer
    &::before
      content: ""
      display: block
      position: absolute
      top: 1px
      left: 1px
      width: 15px
      height: 15px
      border: 1px solid #999
      border-radius: 50%
  &:checked + label
    color: #1abc9c
    &::after
      content: ""
      display: block
      position: absolute
      top: 3px
      left: 3px
      width: 11px
      height: 11px
      background: #1abc9c
      border-radius: 50%
</style>



// WEBPACK FOOTER //
// Index.vue?76f6b9d4